import clientApi from 'api/clientApi';
import { MESSAGE } from 'constants';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

export const useClientDetails = () => {
    const { id } = useParams();
    const [clientDetails, setClientDetails] = useState({});

    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState({
        title: '',
        type: '',
        contents: []
    });


    useEffect(() => {
        (async function getClientDetails() {
            try {
                setIsLoading(true);
                /**Call Api */
                const params = {
                    id: id,
                }
                const dtRes = await clientApi.getDetails(params);
                setClientDetails(dtRes.data?.clientInfo || {});
                setIsLoading(false);

            } catch (err) {
                setIsLoading(false);
                const errMsg = {
                    type: MESSAGE.ERROR,
                    contents: [err]
                }
                setMessage(errMsg);
            }
        })();
        return;
    }, [id]);

    return { clientDetails, isLoading, message, setMessage };
}

